// frontend/src/pages/Dashboard/Author/MyArticles.js

import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import axiosInstance from '../../../utils/axiosConfig';

const MyArticles = () => {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [articles, setArticles] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchMine = async () => {
    try {
      const { data } = await axiosInstance.get('/author-articles/my');
      setArticles(data);
    } catch {
      setError('Fehler: Eigene Artikel konnten nicht geladen werden.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMine();
  }, []);

  return (
    <div className="flex min-h-screen">
      {/* SIDEBAR */}
      <div className={`${sidebarOpen ? 'block' : 'hidden'} sm:block bg-gray-100 w-64 p-4`}>
        {/* Schliessen-Button (mobil) */}
        <button onClick={() => setSidebarOpen(false)} className="sm:hidden mb-4">
          <XMarkIcon className="w-6 h-6 text-gray-600" />
        </button>

        {/* Zurück-Button */}
        <button
          onClick={() => navigate(-1)}
          className="bg-primary text-white w-full text-left px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          ← Zurück
        </button>

        {/* Author Links */}
        <Link
          to="/author/dashboard"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600 mb-2"
        >
          Autor-Dashboard
        </Link>
        <Link
          to="/author/my-articles"
          className="block bg-primary text-white px-4 py-2 rounded hover:bg-orange-600"
        >
          Meine Artikel
        </Link>
      </div>

      {/* MAIN CONTENT */}
      <div className="flex-1 p-4">
        {/* Menü öffnen (mobil) */}
        <button onClick={() => setSidebarOpen(true)} className="sm:hidden mb-4">
          <Bars3Icon className="w-6 h-6 text-gray-600" />
        </button>

        <motion.div className="py-8" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <h1 className="text-3xl font-heading text-primary mb-6">Meine Artikel</h1>
          {error && <div className="bg-red-100 text-red-700 p-2 mb-4">{error}</div>}

          <Link
            to="/author/my-articles/add"
            className="bg-primary text-white px-4 py-2 rounded hover:bg-orange-600"
          >
            Neuen Artikel hinzufügen
          </Link>

          {loading ? (
            <div className="flex justify-center">
              <div className="loader" />
            </div>
          ) : articles.length === 0 ? (
            <p className="mt-4">Keine Artikel vorhanden.</p>
          ) : (
            <div className="overflow-x-auto mt-4">
              <table className="min-w-full bg-white text-center">
                <thead>
                  <tr>
                    <th className="border px-4 py-2">Titel</th>
                    <th className="border px-4 py-2">Veröffentlicht</th>
                    <th className="border px-4 py-2">Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {articles.map((art) => (
                    <tr key={art._id}>
                      <td className="border px-4 py-2">{art.title}</td>
                      <td className="border px-4 py-2">{art.isPublished ? 'Ja' : 'Nein'}</td>
                      <td className="border px-4 py-2">
                        <Link
                          to={`/author/my-articles/edit/${art._id}`}
                          className="bg-blue-500 text-white px-3 py-1 rounded"
                        >
                          Bearbeiten
                        </Link>
                        {/* kein Löschen */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default MyArticles;
